import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=49c6cfa3&scoped=true"
import script from "./formBox.vue?vue&type=script&lang=js"
export * from "./formBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c6cfa3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c6cfa3')) {
      api.createRecord('49c6cfa3', component.options)
    } else {
      api.reload('49c6cfa3', component.options)
    }
    module.hot.accept("./formBox.vue?vue&type=template&id=49c6cfa3&scoped=true", function () {
      api.rerender('49c6cfa3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/examine/components/formBox.vue"
export default component.exports